import { BaseApiError } from '@/services/shared';

export interface PatientNoteApi {
  id: string;
  patient_id: string;
  author_id: string;
  content_markdown: string;
  created_at: string;
  updated_at: string;
}

export interface PaginatedPatientNotesApi {
  items: PatientNoteApi[];
  page: number;
  page_size: number;
  total_items: number;
}

export interface PatientNote {
  id: string;
  patientId: string;
  authorId: string;
  contentMarkdown: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedPatientNotes {
  items: PatientNote[];
  page: number;
  pageSize: number;
  totalItems: number;
}

export interface PatientNoteListRequest {
  dietitianId: string;
  patientId: string;
  page?: number;
  pageSize?: number;
}

export interface CreatePatientNoteRequest {
  dietitianId: string;
  patientId: string;
  contentMarkdown: string;
}

export interface UpdatePatientNoteRequest {
  dietitianId: string;
  patientId: string;
  noteId: string;
  contentMarkdown: string;
}

export class PatientNotesApiError extends BaseApiError {
  constructor(message: string, status?: number, fieldErrors?: Record<string, string>, code?: string) {
    super(message, status, fieldErrors, code);
    this.name = 'PatientNotesApiError';
  }
}
